export default class ErrorPage {
  static conflictError () : void {
    window.location.href = '/409.html'
  }

  static unprocessableEntityError () : void {
    window.location.href = '/422.html'
  }
}
